export default __webpack_public_path__ + "static/media/print.6fc53e13.svg";